// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      id="CnaIcon__Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 551.89 67.74"
      height={67.74}
      width={551.89}
      {...props}
    >
      <defs>
        <style>
          {".CnaIcon__cls-1{fill:#004289}.CnaIcon__cls-2{fill:#dc0814}"}
        </style>
      </defs>
      <path
        className="CnaIcon__cls-1"
        d="M333.73 78.52c4 0 5.65-1.6 5.65-5.35V60.78h-24.85V73.3c0 3.69 1.58 5.22 5.8 5.22h1.13v2.71h-24.18v-2.71h1.28c3.84 0 5.57-1.6 5.57-5.08V45.76c0-3.48-1.66-5.08-5.65-5.08h-1.2V38h24.18v2.72h-1.06c-3.92 0-5.87 1.18-5.87 5.08v10.88h24.85V46c0-3.89-1.65-5.28-6-5.28h-.68V38h24.1v2.72h-1.35c-3.85 0-5.65 1.32-5.65 5.08v27.5c0 3.62 1.43 5.22 5.8 5.22h1.2v2.71h-24.1v-2.71zm41.34-13.35-3.28 8.13c-1.41 3.55-1.33 5.22 6.18 5.22h1v2.71h-20.7v-2.71h1.17c3.75 0 5.71-1.53 7.66-6.4l13.37-33.18-.86-2h11.57l15.63 35.34c2 4.59 3.75 6 7.81 6.26v2.71h-25.4v-2.73H392c4.77 0 5.47-1.88 3.91-5.29l-3.68-8.06zm8.13-20.11-6.56 16.28h13.75zm51.59 28.38c0 3.55 1.66 5.08 5.95 5.08H443v2.71h-26.36v-2.71h1.21c4.59 0 6.55-1 6.55-5.08V46c0-3.33-1-5.28-6-5.28h-1.58V38c3.77-.2 6.63-.35 9.72-.55 4.22-.28 9.64-.49 12.35-.49 11.07 0 17.1 1.32 20.86 4.8a10.39 10.39 0 0 1 3.62 7.93c0 5.29-4.15 9.46-11.15 11.2 5 3.83 7.58 8.56 12.92 13.5 3.09 2.85 5.23 3.75 10 4.17v2.71c-1.66.07-2.44 0-4.7 0-9.34 0-13.18-1.25-16.72-4.52-3.77-3.47-8.11-10-12.93-13.84h-5.95zm0-13.49h2.94c9.11 0 14.39-2.58 14.39-10s-6.11-10-13.41-10h-3.92zM477 38c4.06-.2 8.73-.35 12.12-.55 3.77-.21 6.63-.35 10.32-.35 15.07 0 22.14 1.74 27.72 6.89a19.41 19.41 0 0 1 6.33 14.6 21.47 21.47 0 0 1-7 15.59c-3.84 3.55-10.09 7.09-25.53 7.09H477v-2.75c5 0 7-.9 7-4.87V46.8c0-4.94-1.2-6.12-7-6.12zm17.4 35.21c0 4.65.75 5.28 6.55 5.28 17 0 21.31-10.71 21.31-19 0-5.77-2.18-11-5.57-14.12-3.69-3.41-8.74-5-16.42-5a42.63 42.63 0 0 0-5.87.35zm71.36.16c0 3.34 1.13 5.15 6.55 5.15h1.13v2.71h-25.68v-2.71h1.88c4.52 0 5.73-1.88 5.73-5v-9.68L539.17 44c-2.18-2.65-3.09-3.27-6.85-3.27h-.53V38h24.56v2.72h-.91c-4.37 0-5 1.67-3.39 3.55l12.05 14.64 8.74-12.67c2-2.85 2.56-5.56-2.71-5.56h-.91V38H587v2.72c-4.37.28-5.65 1-8.36 4.87l-12.88 18.25z"
        transform="translate(-35.11 -25.29)"
      />
      <path
        className="CnaIcon__cls-2"
        d="M42.31 58.82 60.95 8.11h17.61l8.93 23.49 9.2-23.49h18.09L96.06 58.82H78.81l-8.65-23.11-8.79 23.11H42.31z"
      />
      <path
        className="CnaIcon__cls-2"
        d="M180.75 33.4h-24.2l-18.74 50.71h17.8l3.45-8.9h19l3.49 8.9h17.65zm-18.33 30.82 6-15.3 6.19 15.3zm-90.35 1.4h5.35c.1 0-6.88 18.49-6.88 18.49s-9 .1-10 .08c-11.24 0-17.91-4.82-21.71-10.79a26.42 26.42 0 0 1-3.69-12.87c0-7.66 4.47-15.74 10.49-20.67 5.48-4.32 9.59-6.21 19.55-6.41H89.9l-6.79 17.67h-9.29c-.69 0-8.85.05-9.82.13a8.84 8.84 0 0 0-7.59 7.35c-.74 4.5 2.31 6.77 5 6.82 6.32.16 10.66.2 10.66.2z"
        transform="translate(-35.11 -25.29)"
      />
      <path
        fill="none"
        stroke="#aaaaa9"
        strokeWidth={2.28}
        d="M203.12 67.35 227.73.39"
      />
    </svg>
  );
};

const CnaIcon = Icon;
export default CnaIcon;
